"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setLocationData", {
  enumerable: true,
  get: function get() {
    return _location.setLocationData;
  }
});
Object.defineProperty(exports, "getLocationData", {
  enumerable: true,
  get: function get() {
    return _location.getLocationData;
  }
});
Object.defineProperty(exports, "getBrowserLocation", {
  enumerable: true,
  get: function get() {
    return _location.getBrowserLocation;
  }
});
Object.defineProperty(exports, "getBrowserLocationPermission", {
  enumerable: true,
  get: function get() {
    return _location.getBrowserLocationPermission;
  }
});
Object.defineProperty(exports, "pruneObject", {
  enumerable: true,
  get: function get() {
    return _transformation.pruneObject;
  }
});
Object.defineProperty(exports, "transformGeoPlaceObject", {
  enumerable: true,
  get: function get() {
    return _transformation.transformGeoPlaceObject;
  }
});
Object.defineProperty(exports, "getCanonicalSearchUrl", {
  enumerable: true,
  get: function get() {
    return _url.getCanonicalSearchUrl;
  }
});
exports.findTagByType = void 0;

var _location = require("./location");

var _transformation = require("./transformation");

var _url = require("./url");

/*
 * @param tagType -- string -- oneOf([CATEGORY_TAG_TYPE, FORMAT_TAG_TYPE])
 * @param tags array
 *
 * Returns first tag that matches passed in type
 */
var findTagByType = function findTagByType(tagType, tags) {
  return tags.find(function (tag) {
    return tag.indexOf(tagType) > -1;
  });
};

exports.findTagByType = findTagByType;
//# sourceMappingURL=index.js.map